import { render, staticRenderFns } from "./UserPools.vue?vue&type=template&id=47237a92&scoped=true&"
import script from "./UserPools.vue?vue&type=script&lang=js&"
export * from "./UserPools.vue?vue&type=script&lang=js&"
import style0 from "./UserPools.vue?vue&type=style&index=0&id=47237a92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47237a92",
  null
  
)

export default component.exports